import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  connectImsTitle: {
    id: 'tGrfcs',
    defaultMessage: 'Connect your Inventory Management Software',
    description: 'Title for the IMS connection step in FTU wizard',
  },
  connectImsDescription: {
    id: '1s10Il',
    defaultMessage:
      'Connect your Inventory Management Software to update ShipStation with stock counts and enable syncing to keep stock levels up to date as you fulfill orders. Generate your API Keys below to then connect to your software.',
    description: 'Description explaining IMS connection benefits and process',
  },
  generateApiKeysTitle: {
    id: 'Ozfnan',
    defaultMessage: 'Generate your ShipStation API keys',
    description: 'Title for the API key generation section',
  },
  generateApiKeysDescription: {
    id: 'INXwwJ',
    defaultMessage: 'Once generated, your secret key will be displayed only once. If needed, you can generate a new key at any time.',
    description: 'Description explaining API key generation process',
  },
  generateApiKey: {
    id: '2JI1xm',
    defaultMessage: 'Generate API Key',
    description: 'Button text for generating API keys',
  },
  selectImsTitle: {
    id: 'P7tguf',
    defaultMessage: 'Select your Inventory Management System',
    description: 'Title for the IMS selection section',
  },
  selectImsDescription: {
    id: 'j4ViKB',
    defaultMessage: 'Once selected you can then connect your IMS using the API and secret key from above.',
    description: 'Description explaining how to use the generated API keys with selected IMS',
  },
  learnMore: {
    id: 'O5AXMH',
    defaultMessage: 'Learn More',
    description: 'Link text to learn more about IMS integration',
  },
  setUp: {
    id: 'x1fJNO',
    defaultMessage: 'Set up',
    description: 'Text for setting up IMS connection',
  },
  mfaModalTitle: {
    id: 'i/x2RK',
    defaultMessage: 'Manage API Key Settings',
    description: 'Title for the MFA step-up authentication modal',
  },
  notAccountOwnerMessage: {
    id: 'mm4Tvn',
    defaultMessage: '<b>API keys can only be generated by the account owner.</b> Contact your account owner for assistance.',
    description: 'Message explaining that API keys can only be generated by the account owner.',
  },
  limitReachedToolTipContent: {
    id: 'PyTdZN',
    defaultMessage:
      'Limit reached: You can only have {apiKeyLimit} API {apiKeyLimit, plural, one {key} other {keys}}. Delete {keyCountToDelete, plural, one {# key} other {# keys}} to create a new key.',
    description: 'Message for the tooltip when the API V1 limit reached',
  },
});
